export default __webpack_public_path__ + "static/wallpaper-5-mb-e0f171c4cfe4159da278f9bfa14a014c.png";